<template>
	<div style="display: flex;height: 100%">
		<p style="margin: auto">请前往公众号打开个人中心里的'个人信息'页面</p>
	</div>
</template>

<script>
	import { testByPerson } from "../api/clear";
	// import { mapGetters } from 'vuex'

    export default {
        name: "clear",
        // computed: {
        //     ...mapGetters(['userOpenid','userPhone'])
        // },
		mounted () {
            localStorage.clear();
            console.log(localStorage,'localStorage');
            this.Cookies.remove('userOpenId');
            this.Cookies.remove('userId');
            this.Cookies.remove('beforeUrl');
		}
    }
</script>

<style scoped>

</style>
